import React, { useCallback, useEffect } from 'react'
import SignatureBanner from '../../components/SignatureBanner'
import MyContentsComponent from '../MyContents/components/MyContentsComponent'
import HomeHeader from '../../components/HomeHeader'
import Footer from '../../components/Footer'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'

import HelpButton from '../../components/HelpButton'
import Sidebar from '../../components/SideBar'
import ContentLoader from 'react-content-loader'
import SubscriptionsList from '../SubscriptionList/components/SubscriptionsListComponent'
import { changeShowInformation } from '../../store/modules/showInformation/action'
import { Container } from '../../components/CanInterest/styles'
import RecentView from '../../components/RecentView'
import ContinueContent from '../../components/ContinueContent'
import ModalIdentification from '../../components/ModalIdentification'
import { editStudentIdentification } from '../../store/modules/student/actions'
import CanInterest from '../../components/CanInterest'

// component for banner promotional:
import CampaignBanners from '../../components/CampaignBanners'
import { TrackingSchemaTypes } from '../../tracking'
import { useTracking } from 'react-tracking'
import { useGetContinueContent } from './hooks/use-get-continue-content'
import { useGetRecentViewCourses } from './hooks/use-get-recent-view-courses'
import InformationMessage from './components/InformationMessage'
import { useGetIsSocialCampaign } from './hooks/use-get-is-social-campaign'
import JoyrideHome from './components/JoyrideHome'
import { useGetBanners } from './hooks/use-get-banners'
import {
  ModalWelcomeSubscription,
  WrapperContainer,
} from 'pages/Subscription/components/SubscriptionContent/styles'

const CampaignEndDate = new Date('2023-09-11 07:50:59')

const Contents: React.FC = () => {
  const { profile } = useSelector((state: RootState) => state.student)
  const { recentView } = useSelector((state: RootState) => state.recentView)
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const { showHomeGuide } = useSelector((state: RootState) => state.showGuide)
  const { subscriptions, status: subscriptionStatus } = useSelector(
    (state: RootState) => state.subscription
  )

  const learningCourses = useSelector((state: RootState) => state.learningCourses)
  const { showInformation } = useSelector((state: RootState) => state.showInformation)
  const dispatch = useDispatch()
  const { trackEvent } = useTracking()

  const detectMob = useCallback(() => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ]

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
  }, [])

  const isMobile = detectMob()

  const isSubscription = subscriptions.length > 0
  const hasCourses = learningCourses.data.length > 0
  const hasCampaign = new Date() < CampaignEndDate

  const swrContinueContent = useGetContinueContent()
  const loadingContinueContent = swrContinueContent.isLoading
  const continueContent = swrContinueContent.isLoading
    ? []
    : swrContinueContent.data.lastConsumedContent

  const swrRecentViewCourses = useGetRecentViewCourses(recentView)
  const loadingRecentView = swrRecentViewCourses.isLoading
  const recentViewCourses = swrRecentViewCourses.isLoading ? [] : swrRecentViewCourses.data

  const swrSocialCampaign = useGetIsSocialCampaign()
  const isSocialCampaign = swrSocialCampaign.isLoading ? false : swrSocialCampaign.data.showMessage

  const swrBanners = useGetBanners()
  const banners = swrBanners.isLoading ? false : swrBanners.data

  useEffect(() => {
    dispatch(changeShowInformation(true))
  }, [dispatch])

  useEffect(() => {
    if (profile && !profile.tracked) {
      trackEvent({
        event: TrackingSchemaTypes.SignIn,
        properties: {
          Id: profile?._id,
          Nome: profile?.name,
          Email: profile?.email,
        },
      })

      dispatch(editStudentIdentification({ ...profile, tracked: true }))
    }
  }, [dispatch, profile, trackEvent])

  useEffect(() => {
    let Produto = null
    let Plano = null
    let Produtos = []

    if (subscriptionStatus !== 'success' || learningCourses.status !== 'success') {
      return
    }

    if (subscriptions && subscriptions.length) {
      Plano = 'Assinatura'

      if (subscriptions.find((s) => s.name === 'Assinatura Vitalícia Premium')) {
        Produto = 'Assinatura Vitalícia Premium'
      } else if (subscriptions.find((s) => s.name === 'Assinatura Vitalícia')) {
        Produto = 'Assinatura Vitalícia'
      } else if (subscriptions.find((s) => s.name === 'Assinatura Ouro')) {
        Produto = 'Assinatura Ouro'
      } else if (subscriptions.find((s) => s.name === 'Assinatura Essencial')) {
        Produto = 'Assinatura Essencial'
      } else if (subscriptions.find((s) => s.name === 'Assinatura Degustação')) {
        Produto = 'Assinatura Degustação'
      }

      if (Produto) {
        Produtos = [Produto]
      }
    }

    if (learningCourses?.data?.length) {
      const activeCourses = learningCourses?.data.filter(
        (c) => c.active && (!c.finalDate || (c.finalDate && new Date(c.finalDate) > new Date()))
      )
      const someCompletePackage = activeCourses.find((l) => l.completePackage)
      const everyAreIncompletePackage = activeCourses.every((l) => !l.completePackage)

      if (!Plano) {
        if (someCompletePackage) {
          Produto = someCompletePackage.name
          Plano = 'Curso'
        } else if (everyAreIncompletePackage) {
          Produto = activeCourses[0]?.name || ''
          Plano = 'Módulo'
        }
      }

      if (activeCourses.length) {
        Produtos = [...(Produtos || []), ...activeCourses.map((c) => c?.name || '')]
      }
    }

    trackEvent({
      event: TrackingSchemaTypes.UpdateIdentifyUser,
      properties: {
        Id: profile?._id,
        Nome: profile?.name,
        Email: profile?.email,
        Plano: Plano || 'Gratuito',
        Produto: Produto || '',
        Produtos,
      },
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptions, learningCourses, profile])

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <>
      <Sidebar />
      <HomeHeader />
      <main>
        {showInformation && isSocialCampaign && hasCampaign && (
          <WrapperContainer>
            <ModalWelcomeSubscription>
              <InformationMessage />
            </ModalWelcomeSubscription>
          </WrapperContainer>
        )}
        <ModalIdentification
          onClose={() =>
            dispatch(editStudentIdentification({ ...profile, showHowKnow: !profile.showHowKnow }))
          }
          open={profile.showHowKnow}
        />
        {showHomeGuide && <JoyrideHome isDarkMode={isDarkMode} isMobile={isMobile} />}
        {banners && <CampaignBanners banner={banners} />}
        {subscriptionStatus === 'success' && !isSubscription && !banners && <SignatureBanner />}
        <Container>
          <h2 className="title">Olá, {profile.name.split(' ').slice(0, 1).join()}!</h2>
        </Container>
        <ContinueContent content={continueContent} />
        {loadingRecentView || loadingContinueContent ? (
          <ContentLoader width={'95%'} height={500} viewBox={'0 0 100% 100%'} {...LoaderProps}>
            <rect x="100" y="20" rx="9" ry="9" width="90%" height="400" />
          </ContentLoader>
        ) : recentViewCourses.length ? (
          <RecentView courses={recentViewCourses} />
        ) : (
          <div />
        )}
        {learningCourses.status === 'loading' && (
          <ContentLoader width={'95%'} height={500} viewBox={'0 0 100% 100%'} {...LoaderProps}>
            <rect x="100" y="20" rx="9" ry="9" width="90%" height="400" />
          </ContentLoader>
        )}
        {hasCourses && <MyContentsComponent />}
        {subscriptionStatus === 'loading' && (
          <ContentLoader width={'95%'} height={500} viewBox={'0 0 100% 100%'} {...LoaderProps}>
            <rect x="100" y="20" rx="9" ry="9" width="90%" height="400" />
          </ContentLoader>
        )}
        {isSubscription && <SubscriptionsList />}
        {!isSubscription ? <CanInterest /> : <div />}
        <HelpButton />
      </main>

      <Footer />
    </>
  )
}

export default Contents
